import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'

const SubDetail = styled(BodyText)`
  margin-inline-start: ${rem(28)};
`

export default SubDetail
